var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _g2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g4, _path37, _g5, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel8Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint0_linear_7088_3826)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint1_linear_7088_3826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.87 267.009L389.87 251.99L685.002 241.477Z",
    fill: "url(#paint2_linear_7088_3826)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint3_linear_7088_3826)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint4_linear_7088_3826)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.08 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint5_linear_7088_3826)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.09 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint6_linear_7088_3826)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint7_linear_7088_3826)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint8_linear_7088_3826)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.999 0.989276L402.263 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint9_linear_7088_3826)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint10_linear_7088_3826)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint11_linear_7088_3826)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint12_radial_7088_3826)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint13_radial_7088_3826)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.127 213.354L336.963 188.579L266.47 174.818C263.448 190.301 272.58 201.729 281.474 203.465L332.127 213.354Z",
    fill: "url(#paint14_linear_7088_3826)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.41 213.836L336.247 189.062L267.553 175.651C264.531 191.135 273.663 202.562 282.557 204.299L331.41 213.836Z",
    stroke: "url(#paint15_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M332.594 236.49L337.43 211.716L278.936 200.297C275.913 215.78 285.046 227.208 293.94 228.944L332.594 236.49Z",
    fill: "url(#paint16_linear_7088_3826)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.594 236.49L337.43 211.716L278.936 200.297C275.913 215.78 285.046 227.208 293.94 228.944L332.594 236.49Z",
    stroke: "url(#paint17_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.939 262.541L353.776 237.767L295.282 226.347C292.259 241.831 301.391 253.258 310.285 254.995L348.939 262.541Z",
    fill: "url(#paint18_linear_7088_3826)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M348.939 262.541L353.776 237.767L295.282 226.347C292.259 241.831 301.391 253.258 310.285 254.995L348.939 262.541Z",
    stroke: "url(#paint19_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.626 324.595V270.365H367.106V342.8L336.584 326.206C335.993 325.885 335.626 325.267 335.626 324.595Z",
    fill: "#ECD8BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.626 324.595V270.365H367.106V342.8L336.584 326.206C335.993 325.885 335.626 325.267 335.626 324.595Z",
    stroke: "url(#paint20_linear_7088_3826)",
    strokeWidth: 0.611267
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.092 323.018V297.871H338.683V323.359L338.854 323.387C339.42 323.482 340.048 323.816 340.562 324.305C341.075 324.793 341.454 325.418 341.548 326.077L341.564 326.187L358.109 333.936V306.261H357.7V333.293L341.935 325.909C341.8 325.18 341.378 324.517 340.844 324.009C340.332 323.521 339.702 323.161 339.092 323.018Z",
    fill: "url(#paint21_linear_7088_3826)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.677 331.797C358.118 331.051 358.144 329.994 358.11 329.311L357.701 329.331C357.735 330.011 357.699 330.957 357.325 331.589C357.144 331.895 356.888 332.12 356.519 332.213C356.144 332.307 355.626 332.27 354.912 331.993L354.764 332.374C355.523 332.669 356.132 332.732 356.619 332.609C357.112 332.486 357.451 332.179 357.677 331.797Z",
    fill: "#D4B195"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.519 324.595V270.365H423.038V342.8L453.561 326.206C454.151 325.885 454.519 325.267 454.519 324.595Z",
    fill: "#ECD8BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.519 324.595V270.365H423.038V342.8L453.561 326.206C454.151 325.885 454.519 325.267 454.519 324.595Z",
    stroke: "url(#paint22_linear_7088_3826)",
    strokeWidth: 0.611267
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.052 323.018V297.871H451.461V323.359L451.29 323.387C450.725 323.482 450.096 323.816 449.583 324.305C449.07 324.793 448.69 325.418 448.596 326.077L448.581 326.187L432.035 333.936V306.261H432.444V333.293L448.21 325.909C448.344 325.18 448.767 324.517 449.301 324.009C449.813 323.521 450.442 323.161 451.052 323.018Z",
    fill: "url(#paint23_linear_7088_3826)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.467 331.797C432.026 331.051 432.001 329.994 432.035 329.311L432.443 329.331C432.409 330.011 432.446 330.957 432.819 331.589C433 331.895 433.256 332.12 433.625 332.213C434 332.307 434.519 332.27 435.232 331.993L435.381 332.374C434.622 332.669 434.012 332.732 433.526 332.609C433.032 332.486 432.693 332.179 432.467 331.797Z",
    fill: "#D4B195"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M457.599 214.152L452.762 189.378L523.255 175.616C526.278 191.1 517.145 202.527 508.252 204.264L457.599 214.152Z",
    fill: "url(#paint24_linear_7088_3826)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M458.315 214.635L453.479 189.861L522.172 176.45C525.195 191.934 516.062 203.361 507.169 205.097L458.315 214.635Z",
    stroke: "url(#paint25_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M457.132 237.289L452.295 212.515L510.79 201.096C513.812 216.579 504.68 228.007 495.786 229.743L457.132 237.289Z",
    fill: "url(#paint26_linear_7088_3826)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M457.132 237.289L452.295 212.515L510.79 201.096C513.812 216.579 504.68 228.007 495.786 229.743L457.132 237.289Z",
    stroke: "url(#paint27_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M440.786 263.34L435.95 238.566L494.444 227.146C497.467 242.63 488.334 254.057 479.44 255.794L440.786 263.34Z",
    fill: "url(#paint28_linear_7088_3826)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M440.786 263.34L435.95 238.566L494.444 227.146C497.467 242.63 488.334 254.057 479.44 255.794L440.786 263.34Z",
    stroke: "url(#paint29_linear_7088_3826)",
    strokeWidth: 1.40232
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.301 267.309H428.54V352.694L395.294 369.594C394.791 369.85 394.195 369.849 393.693 369.591L361.301 352.987V267.309Z",
    fill: "url(#paint30_linear_7088_3826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.301 267.309H428.54V352.694L395.294 369.594C394.791 369.85 394.195 369.849 393.693 369.591L361.301 352.987V267.309Z",
    stroke: "url(#paint31_linear_7088_3826)",
    strokeWidth: 1.22253
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.7 364.202L395.294 368.983C394.79 369.239 394.195 369.238 393.692 368.981L383.917 363.97V301.539H404.7V364.202Z",
    fill: "url(#paint32_linear_7088_3826)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.969 313.152H365.943V351.369L394.679 366.223L423.899 351.367V313.152H424.873V351.713L394.675 366.944L364.969 351.712V313.152Z",
    fill: "url(#paint33_linear_7088_3826)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.879 352.885V363.975H394.348V352.885H394.879Z",
    fill: "url(#paint34_linear_7088_3826)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.02 360.039C391.963 361.259 390.674 361.53 389.787 361.383L389.874 360.858C390.581 360.976 391.684 360.769 392.619 359.691C393.558 358.609 394.347 356.622 394.347 353.15H394.879C394.879 356.692 394.074 358.824 393.02 360.039Z",
    fill: "url(#paint35_linear_7088_3826)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.206 360.039C397.264 361.259 398.552 361.53 399.439 361.383L399.352 360.858C398.645 360.976 397.543 360.769 396.608 359.691C395.669 358.609 394.879 356.622 394.879 353.15H394.348C394.348 356.692 395.152 358.824 396.206 360.039Z",
    fill: "url(#paint36_linear_7088_3826)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.502 364.215L388.502 360.854L389.83 360.854L394.613 363.682L399.394 360.83H400.567L394.722 364.216C394.652 364.248 394.572 364.248 394.502 364.215Z",
    fill: "url(#paint37_linear_7088_3826)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7088_3826)"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M389.953 155.701L323.937 191.614C320.592 193.433 318.511 196.935 318.511 200.742L318.511 282.834C318.511 286.641 320.592 290.143 323.937 291.962L389.953 327.875C393.05 329.559 396.789 329.559 399.885 327.875L465.902 291.962C469.246 290.143 471.327 286.641 471.327 282.834L471.328 200.742C471.328 196.935 469.246 193.433 465.902 191.614L399.885 155.701C396.789 154.017 393.05 154.017 389.953 155.701Z",
    fill: "url(#paint38_linear_7088_3826)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M389.881 169.138L335.53 198.704C332.199 200.517 330.125 204.006 330.125 207.798L330.125 275.468C330.125 279.26 332.199 282.749 335.53 284.562L389.881 314.128C392.965 315.806 396.69 315.806 399.775 314.128L454.125 284.562C457.457 282.749 459.53 279.26 459.53 275.468L459.53 207.798C459.53 204.006 457.457 200.517 454.125 198.704L399.775 169.138C396.69 167.46 392.965 167.46 389.881 169.138Z",
    fill: "url(#paint39_linear_7088_3826)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.881 169.138L335.53 198.704C332.199 200.517 330.125 204.006 330.125 207.798L330.125 275.468C330.125 279.26 332.199 282.749 335.53 284.562L389.881 314.128C392.965 315.806 396.69 315.806 399.775 314.128L454.125 284.562C457.457 282.749 459.53 279.26 459.53 275.468L459.53 207.798C459.53 204.006 457.457 200.517 454.125 198.704L399.775 169.138C396.69 167.46 392.965 167.46 389.881 169.138Z",
    stroke: "url(#paint40_linear_7088_3826)",
    strokeWidth: 0.611267
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7088_3826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 173,
    width: 120,
    height: 137
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M390.523 175.114L340.772 202.154C337.601 203.877 335.627 207.197 335.627 210.806L335.627 272.696C335.627 276.305 337.601 279.625 340.772 281.348L390.523 308.388C393.455 309.981 396.996 309.981 399.928 308.388L449.679 281.348C452.85 279.625 454.824 276.305 454.824 272.696L454.824 210.806C454.824 207.197 452.85 203.877 449.679 202.154L399.928 175.114C396.996 173.521 393.455 173.521 390.523 175.114Z",
    fill: "#A6D3DE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.523 175.114L340.772 202.154C337.601 203.877 335.627 207.197 335.627 210.806L335.627 272.696C335.627 276.305 337.601 279.625 340.772 281.348L390.523 308.388C393.455 309.981 396.996 309.981 399.928 308.388L449.679 281.348C452.85 279.625 454.824 276.305 454.824 272.696L454.824 210.806C454.824 207.197 452.85 203.877 449.679 202.154L399.928 175.114C396.996 173.521 393.455 173.521 390.523 175.114Z",
    fill: "url(#paint41_radial_7088_3826)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.262 313.675L382.895 169.816H407.556L405.188 313.675H385.262Z",
    fill: "url(#paint42_linear_7088_3826)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M384.945 312.399L310.966 188.998L332.323 176.667L402.202 302.436L384.945 312.399Z",
    fill: "url(#paint43_linear_7088_3826)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.891 302.435L452.77 176.666L474.127 188.997L400.147 312.398L382.891 302.435Z",
    fill: "url(#paint44_linear_7088_3826)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.627,
    y: 233.525,
    width: 119.197,
    height: 77.4096,
    fill: "url(#paint45_linear_7088_3826)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_7088_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.523 175.114L340.772 202.154C337.601 203.877 335.627 207.197 335.627 210.806L335.627 272.696C335.627 276.305 337.601 279.625 340.772 281.348L390.523 308.388C393.455 309.981 396.996 309.981 399.928 308.388L449.679 281.348C452.85 279.625 454.824 276.305 454.824 272.696L454.824 210.806C454.824 207.197 452.85 203.877 449.679 202.154L399.928 175.114C396.996 173.521 393.455 173.521 390.523 175.114Z",
    fill: "#6052B4",
    fillOpacity: 0.01
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M408.176 213.333C406.271 213.312 404.771 213.896 404.203 215.132C401.424 221.185 398.256 225.764 394.553 229.442C394.928 229.567 395.292 229.721 395.643 229.903C397.228 230.722 398.726 232.073 399.952 233.666C401.177 235.26 402.13 237.097 402.487 238.974C402.578 239.451 402.629 239.936 402.628 240.419C407.383 237.447 413.006 235.389 419.817 234.158C421.636 233.829 422.702 230.665 422.428 227.002L418.139 226.88L421.868 223.852C421.361 222.082 420.524 220.344 419.286 218.884C417.392 216.649 414.842 215.056 412.366 214.164L409.198 216.066L409.541 213.443C409.068 213.376 408.613 213.337 408.176 213.332L408.176 213.333ZM392.726 231.409C392.597 231.416 392.475 231.437 392.36 231.467C390.899 232.718 389.358 233.858 387.732 234.917C387.834 234.957 387.935 234.998 388.037 235.043C389.76 235.798 391.384 237.135 392.73 238.78C394.36 240.771 395.612 243.287 395.857 245.826C397.118 244.561 398.448 243.392 399.864 242.321C400.364 241.522 400.466 240.556 400.245 239.401C399.979 238.003 399.191 236.42 398.141 235.054C397.09 233.688 395.776 232.538 394.595 231.928C393.856 231.546 393.234 231.385 392.726 231.409L392.726 231.409ZM385.173 236.69C385.004 236.697 384.845 236.723 384.689 236.759C380.175 239.292 375.039 241.393 369.155 243.591C369.226 243.596 369.295 243.603 369.365 243.61C370.662 243.751 371.937 244.221 373.167 244.937L377.765 242.932L375.835 246.924C376.567 247.587 377.276 248.324 377.952 249.12C380.485 252.101 382.584 255.936 383.698 259.868C383.698 259.869 383.697 259.871 383.698 259.872C384.061 261.154 384.321 262.424 384.468 263.655C387.029 257.745 389.883 252.764 393.295 248.647C394.185 246.026 393.028 242.741 390.969 240.225C389.817 238.817 388.409 237.697 387.122 237.132C386.397 236.815 385.747 236.668 385.173 236.69ZM402.453 243.382C401.561 243.998 400.689 244.664 399.837 245.372C404.615 246.502 407.274 249.73 409.678 252.956C410.955 254.669 412.191 256.385 413.72 257.92C416.671 259.036 418.987 258.698 421.517 256.097C410.272 252.708 409.791 244.798 402.453 243.381L402.453 243.382ZM368.526 245.848C367.2 245.876 366.298 246.551 365.678 247.873C364.969 249.384 364.81 251.835 365.732 254.835C366.433 257.121 367.747 259.437 369.239 261.134C370.732 262.831 372.399 263.828 373.555 263.868H373.559C374.013 263.884 374.359 263.785 374.634 263.532L374.612 263.51L374.867 263.254C374.964 263.112 375.052 262.943 375.134 262.743C375.477 261.901 375.534 260.48 374.909 258.717C374.069 256.348 372.576 254.821 370.837 254.473L368.034 253.916L370.452 252.391L375.146 249.44C373.114 247.388 370.93 246.072 369.121 245.875C368.914 245.853 368.716 245.845 368.526 245.849L368.526 245.848ZM397.351 246.508L394.358 249.604C406.614 251.785 401.124 266.808 413.796 271.101L410.773 264.112C414.77 266.083 418.995 266.872 422.696 265.58C406.13 260.462 410.943 250.087 397.351 246.508ZM376.674 251.171L373.506 253.165C375.114 254.202 376.338 255.919 377.059 257.954C377.373 258.838 377.564 259.687 377.639 260.49L380.499 257.638C379.513 255.296 378.176 253.054 376.674 251.171L376.674 251.171ZM381.356 260.002L376.224 265.126L376.205 265.107C375.686 265.588 375.052 265.933 374.352 266.076C377.191 267.89 379.799 268.436 381.284 267.242C381.804 266.824 382.143 266.222 382.318 265.485C382.268 263.937 382 262.237 381.505 260.494C381.459 260.329 381.407 260.166 381.356 260.002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7088_3826",
    x: 330.43,
    y: 265.17,
    width: 41.8721,
    height: 83.0342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.44507
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.561568 0 0 0 0 0.32375 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7088_3826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7088_3826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7088_3826",
    x: 417.842,
    y: 265.17,
    width: 41.8721,
    height: 83.0342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.44507
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.561568 0 0 0 0 0.32375 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7088_3826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7088_3826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7088_3826",
    x: 355.799,
    y: 261.807,
    width: 78.2422,
    height: 113.479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.44507
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.561568 0 0 0 0 0.32375 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7088_3826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7088_3826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7088_3826",
    x: 314.843,
    y: 154.438,
    width: 160.152,
    height: 183.259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.89014
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8338
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4375 0 0 0 0 0.287401 0 0 0 0 0.111198 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7088_3826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7088_3826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7088_3826",
    x: 329.636,
    y: 167.391,
    width: 130.383,
    height: 148.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09169,
    result: "effect1_foregroundBlur_7088_3826"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_7088_3826",
    x: 335.627,
    y: 173.92,
    width: 119.197,
    height: 135.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.11024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458333 0 0 0 0 0.256743 0 0 0 0 0.0706597 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7088_3826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7088_3826",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7088_3826",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7088_3826",
    x1: 657.591,
    y1: 261.94,
    x2: 389.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7088_3826",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7088_3826",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7088_3826",
    x1: 236.467,
    y1: 14.8011,
    x2: 383.468,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7088_3826",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7088_3826",
    x1: 132.013,
    y1: 119.262,
    x2: 386.628,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7088_3826",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7088_3826",
    x1: 553.656,
    y1: 14.7982,
    x2: 406.655,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7088_3826",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7088_3826",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_7088_3826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9AA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5DE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_7088_3826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9AA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5DE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7088_3826",
    x1: 297.419,
    y1: 206.578,
    x2: 280.527,
    y2: 181.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A86B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7088_3826",
    x1: 270.994,
    y1: 176.323,
    x2: 286.115,
    y2: 204.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#F5E3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#E6CA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7088_3826",
    x1: 309.884,
    y1: 232.057,
    x2: 292.993,
    y2: 206.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7088_3826",
    x1: 282.377,
    y1: 200.968,
    x2: 316.374,
    y2: 241.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#EAD2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7088_3826",
    x1: 326.23,
    y1: 258.108,
    x2: 309.338,
    y2: 233.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7088_3826",
    x1: 298.723,
    y1: 227.019,
    x2: 332.719,
    y2: 267.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#EAD2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7088_3826",
    x1: 335.626,
    y1: 319.733,
    x2: 367.946,
    y2: 327.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208702,
    stopColor: "#C49F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648432,
    stopColor: "#FFF1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827985,
    stopColor: "#B38368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971703,
    stopColor: "#8C5F4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7088_3826",
    x1: 339.6,
    y1: 318.654,
    x2: 351.291,
    y2: 315.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309893,
    stopColor: "#D5B198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523799,
    stopColor: "#CBA68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77229,
    stopColor: "#BB9478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7B49B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7088_3826",
    x1: 454.519,
    y1: 319.733,
    x2: 422.199,
    y2: 327.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208702,
    stopColor: "#C49F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648432,
    stopColor: "#FFF1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827985,
    stopColor: "#B38368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971703,
    stopColor: "#8C5F4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7088_3826",
    x1: 450.544,
    y1: 318.654,
    x2: 438.854,
    y2: 315.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309893,
    stopColor: "#D5B198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523799,
    stopColor: "#CBA68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77229,
    stopColor: "#BB9478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7B49B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7088_3826",
    x1: 492.307,
    y1: 207.376,
    x2: 509.199,
    y2: 182.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A86B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7088_3826",
    x1: 518.731,
    y1: 177.122,
    x2: 503.611,
    y2: 205.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#F5E3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#E6CA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7088_3826",
    x1: 479.841,
    y1: 232.856,
    x2: 496.733,
    y2: 207.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7088_3826",
    x1: 507.349,
    y1: 201.767,
    x2: 473.352,
    y2: 242.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#EAD2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7088_3826",
    x1: 463.496,
    y1: 258.906,
    x2: 480.387,
    y2: 233.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFF5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7088_3826",
    x1: 491.003,
    y1: 227.818,
    x2: 457.006,
    y2: 268.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378992,
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480868,
    stopColor: "#EAD2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729174,
    stopColor: "#D2A86B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7088_3826",
    x1: 394.92,
    y1: 312.542,
    x2: 394.92,
    y2: 370.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2286,
    stopColor: "#B58D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47675,
    stopColor: "#D8B59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88344,
    stopColor: "#B58D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B58D70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7088_3826",
    x1: 361.301,
    y1: 337.299,
    x2: 426.323,
    y2: 359.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208702,
    stopColor: "#FFF5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648432,
    stopColor: "#ECD8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780206,
    stopColor: "#D0A568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971703,
    stopColor: "#8C5F4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7088_3826",
    x1: 394.309,
    y1: 301.539,
    x2: 394.309,
    y2: 369.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22229,
    stopColor: "#DDBFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669825,
    stopColor: "#EBD4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898796,
    stopColor: "#DDBFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDBFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7088_3826",
    x1: 422.046,
    y1: 345.145,
    x2: 397.517,
    y2: 326.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309893,
    stopColor: "#EBD3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523799,
    stopColor: "#E2C69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77229,
    stopColor: "#E3C8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7088_3826",
    x1: 394.613,
    y1: 352.885,
    x2: 394.613,
    y2: 363.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491891,
    stopColor: "#F9EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD5B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7088_3826",
    x1: 392.333,
    y1: 353.15,
    x2: 392.333,
    y2: 361.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FAEDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E9D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7088_3826",
    x1: 396.894,
    y1: 353.15,
    x2: 396.894,
    y2: 361.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEDD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD4B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7088_3826",
    x1: 393.969,
    y1: 361.996,
    x2: 387.077,
    y2: 362.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5CBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309893,
    stopColor: "#FAEDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523799,
    stopColor: "#F3E2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613641,
    stopColor: "#EFDCC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7088_3826",
    x1: 362.828,
    y1: 174.394,
    x2: 431.595,
    y2: 311.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7088_3826",
    x1: 362.217,
    y1: 185.702,
    x2: 421.509,
    y2: 295.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7088_3826",
    x1: 368.635,
    y1: 181.729,
    x2: 432.512,
    y2: 296.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_7088_3826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395.226 241.751) rotate(90) scale(69.1924 59.5986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7088_3826",
    x1: 395.225,
    y1: 169.816,
    x2: 395.225,
    y2: 313.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7088_3826",
    x1: 321.645,
    y1: 182.833,
    x2: 393.574,
    y2: 307.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7088_3826",
    x1: 463.448,
    y1: 182.831,
    x2: 391.519,
    y2: 307.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7088_3826",
    x1: 395.226,
    y1: 267.092,
    x2: 394.866,
    y2: 306.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel8Badge);
export default __webpack_public_path__ + "static/media/Level8Badge.6bb7358ce6aca135be9df88cbe4f42d4.svg";
export { ForwardRef as ReactComponent };